<template>
  <div>
    <!-- 固定顶部导航栏 -->
    <StickyNav :is-visible="isScrolled" />

    <!-- Header 包含封面和内容 -->
    <AppHeader>
      <!-- 主要内容区域 -->
      <section
        class="container mx-auto px-4 pb-8 sm:pb-12 pt-8 sm:pt-12 max-w-[1800px]"
      >
        <div class="flex flex-col lg:flex-row gap-6 lg:gap-10 items-start">
          <!-- 博客列表区域 -->
          <div class="w-full lg:w-[72%] xl:w-[74%]">
            <!-- Top Articles 标题 - 只在博文区域居中 -->
            <div class="text-center pb-4 sm:pb-8">
              <h2 class="text-2xl sm:text-3xl font-airstrip text-gray-600">
                Pop Articles
              </h2>
            </div>

            <!-- 博客列表 -->
            <BlogPostList />
          </div>

          <!-- 个人资料 - 固定在右侧 -->
          <aside class="w-full lg:w-[24%] xl:w-[22%] lg:sticky lg:top-24">
            <ProfileCard />
          </aside>
        </div>
      </section>

      <!-- Topic Cards -->
      <section class="pb-8 sm:pb-12">
        <TopicGrid />
      </section>
    </AppHeader>

    <!-- Footer -->
    <AppFooter />
  </div>
</template>

<script>
import StickyNav from "@/components/StickyNav.vue";
import AppHeader from "@/components/AppHeader.vue";
import BlogPostList from "@/components/BlogPostList.vue";
import ProfileCard from "@/components/ProfileCard.vue";
import TopicGrid from "@/components/TopicGrid.vue";
import AppFooter from "@/components/AppFooter.vue";
import { useScrollNav } from "@/composables/useScrollNav";

export default {
  name: "HomePage",
  components: {
    StickyNav,
    AppHeader,
    BlogPostList,
    ProfileCard,
    TopicGrid,
    AppFooter,
  },
  setup() {
    const { isScrolled } = useScrollNav();

    return {
      isScrolled,
    };
  },
};
</script>
